import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectWorkTypeValue } from '../../services/workTypes/selectors';

interface Props {
    payrollCode?: ?number;
}

export class WorkTypePayrollCode extends React.PureComponent<Props> {
    render() {
        const { payrollCode } = this.props;
        if (!payrollCode) return null;
        return payrollCode;
    }
}

const mapStateToProps = createStructuredSelector({
    payrollCode: makeSelectWorkTypeValue('payrollCode')
});

export default connect(mapStateToProps)(WorkTypePayrollCode);
